// extracted by mini-css-extract-plugin
module.exports = {"leftFooter":"leftFooter-module--left-footer--FIE1M","show":"leftFooter-module--show--3whIx","text":"leftFooter-module--text--3E3t5","link":"leftFooter-module--link--3fu3-"};